<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <div class="mb-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div>
      <h1 class="text-3xl font-bold text-gray-900 mb-2">Purchase order amendments</h1>
      <p class="text-gray-600">Revisions applied to issued or accepted purchase orders</p>
    </div>
    <button
      [routerLink]="'/home/add-po-amendment'"
      class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700"
    >
      Add amendment
    </button>
  </div>

  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-8">
    <input
      type="text"
      placeholder="Search by PO ref, project, or reason..."
      class="block w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:outline-none"
      (input)="applyFilter($event)"
    />
  </div>

  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">#</th>
          <td mat-cell *matCellDef="let element; let i = index" class="px-6 py-4">{{ i + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="poRef">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">PO Ref</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ element.po_ref || ('PO #' + element.po_id) }}</td>
        </ng-container>
        <ng-container matColumnDef="projectName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4">Project</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ element.project_name || '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="amendmentType">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">Type</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ element.amendment_type || '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">Reason</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ element.reason || '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="revisedTotal">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">Revised total</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ element.revised_total_value || '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">Status</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 capitalize">{{ element.status || 'applied' }}</td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">Date</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ element.created_at | date:'mediumDate' }}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">Actions</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">
            <button type="button" class="text-blue-600 hover:underline" (click)="viewPo(element)">View PO</button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div *ngIf="dataSource.data.length === 0" class="text-center py-12 text-gray-500">
      No amendments yet. Open a purchase order and choose Amend.
    </div>

    <div class="px-6 py-4 border-t border-gray-200">
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
